import { Positions } from "../../Positions";
import { getRosterResult } from "../../Results";

const DEFAULT_POINTS: WDLSetPointRules = { win: 1, draw: 0, loss: 0 };

export type PositionSetPointRules = {
  position: number[];
};

export type WDLSetPointRules = {
  win: number;
  draw: number;
  loss: number;
};

export type SetPointRules = PositionSetPointRules | WDLSetPointRules;

export const isPositionSetPointRules = (
  rules: SetPointRules
): rules is PositionSetPointRules => {
  return (rules as PositionSetPointRules).position !== undefined;
};

export const getTeamSetPoints = (
  rosterId: string,
  pointRules: SetPointRules | undefined,
  positions: Positions,
  numWinners: number
) => {
  if (!pointRules) {
    return getTeamWDLSetPoints(rosterId, DEFAULT_POINTS, positions, numWinners);
  }

  return isPositionSetPointRules(pointRules)
    ? getTeamPositionSetPoints(rosterId, pointRules, positions)
    : getTeamWDLSetPoints(rosterId, pointRules, positions, numWinners);
};

export const getTeamPositionSetPoints = (
  teamId: string,
  points: PositionSetPointRules,
  positions: Positions
) => {
  const teamPosition = positions[teamId];
  if (!teamPosition) {
    return 0;
  }

  return points.position[teamPosition - 1] ?? 0;
};

export const getTeamWDLSetPoints = (
  teamId: string,
  points: WDLSetPointRules,
  positions: Positions,
  numWinners: number
) => {
  const teamResult = getRosterResult(teamId, positions, numWinners);
  switch (teamResult) {
    case "W":
      return points.win;
    case "D":
      return points.draw;
    case "L":
      return points.loss;
    default:
      return 0;
  }
};

export const getBestPointsDifferential = (
  points: SetPointRules | undefined
) => {
  if (!points) {
    return 1; // 1 for Win, 0 for Loss
  }

  return isPositionSetPointRules(points)
    ? Math.max(...points.position, 0)
    : points.win - points.loss;
};
